import { useMemo } from 'react'
import { usePortfolioHouseVisits } from '../../StateManagment/PortfolioHouseVisitsContext'
import { aggregateAdressesByProject } from '../../helpers/housevisitsPortfolio/aggregateHouseVisits'
import StaticCardLabel from './StaticCardLabel'
import KpiValue from './KpiValue'
import DashboardCardOptions from './DashboardCardOptions'
import CardHeaderInfoPopover from '../common/CardHeaderInfoPopover'
import ProjectContributionBreakdown from './housevisitsPortfolio/ProjectContributionBreakdown'

// AI-CONTEXT: See docs/patterns.md#dashboard-static-card

/**
 * Stat card in de KPI-rij van een portfolio: alle huishoudens van de projecten
 * met huisbezoeken bij elkaar, met de bijdrage per project in de popover.
 *
 * @param {object} props
 * @param {object} props.item - The DashboardItems doc backing this static card
 */
const DashboardPortfolioHouseVisitsTotalCard = ({ item }) => {
    const { projects, adresses, loading } = usePortfolioHouseVisits()

    const breakdown = useMemo(
        () => aggregateAdressesByProject(projects, adresses).map((row) => ({
            CompagnyID: row.CompagnyID,
            name: row.name,
            value: row.total,
        })),
        [projects, adresses]
    )

    const total = useMemo(
        () => breakdown.reduce((sum, r) => sum + (r.value || 0), 0),
        [breakdown]
    )

    // Geen projecten is een vastgestelde toestand ('—'), geen nul: 0 zou
    // beweren dat er projecten zijn die niemand helpen.
    // AI-CONTEXT: See docs/pitfalls.md#ui-aggregate-collapses-nothing-into-zero
    const isEmpty = !loading && projects.length === 0

    return (
        <div className='participation-value-card'>
            <StaticCardLabel
                title='Totaal huishoudens'
                pill={{ variant: 'housevisits', label: 'Portfolio' }}
            />
            {!isEmpty && !loading && (
                <CardHeaderInfoPopover
                    content={<ProjectContributionBreakdown items={breakdown} valueLabel='Huishoudens' />}
                    label='Bijdrage per project'
                />
            )}
            <KpiValue loading={loading} value={isEmpty ? null : total} />
            {!loading && (
                <p className='participation-value-note'>
                    {isEmpty
                        ? 'Er hangen nog geen projecten met huisbezoeken onder dit portfolio.'
                        : `Over ${projects.length} project${projects.length === 1 ? '' : 'en'}`}
                </p>
            )}
            <DashboardCardOptions item={item} />
        </div>
    )
}

export default DashboardPortfolioHouseVisitsTotalCard
